import { render, staticRenderFns } from "./AddTeacherTrainingTopics.vue?vue&type=template&id=2d8a0c88&scoped=true"
import script from "./AddTeacherTrainingTopics.vue?vue&type=script&lang=js"
export * from "./AddTeacherTrainingTopics.vue?vue&type=script&lang=js"
import style0 from "./AddTeacherTrainingTopics.vue?vue&type=style&index=0&id=2d8a0c88&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d8a0c88",
  null
  
)

export default component.exports